<template>
    <div class="thread-markdown">
        <template v-for="(segment, index) in segments" :key="index">
            <div
                v-if="segment.type === 'markdown'"
                v-html="md.render(segment.text)"
            />
            <HtmlViewer
                v-else
                :content="segment.source"
                class="thread-html-snippet"
                data-testid="thread-html-snippet"
            />
        </template>
    </div>
</template>

<script setup lang="ts">
import MarkdownIt from "markdown-it";
import { computed } from "vue";

import HtmlViewer from "@/components/HtmlViewer.vue";
import { splitThreadContent } from "@/components/Thread/thread-content";

const props = defineProps<{ content: string }>();

const md = new MarkdownIt({ html: false, linkify: true, breaks: true });

const segments = computed(() => splitThreadContent(props.content));
</script>

<style scoped>
.thread-html-snippet {
    display: block;
    max-width: 100%;
    overflow: hidden;
}
</style>
